<template>
  <div class="question4">
    <div class="header">
      <img src="../assets/head.jpeg">
    </div>

    <div class="body">
      <div>
        <p class="title">这是虚拟病例并非真实患者</p>
        <p
          class="content"
        >患者，男，65 岁，因“多饮、多食、消瘦半年，加重 1 周”来诊。1 周前出现明显烦渴、多饮，饮水 量每日达 4000 ml，伴尿量增多，血糖 10.5 mmol/L，尿糖(+++)，平素不规律服用二甲双胍。平素血 糖控制在 FPG 7.0~8.0 mmol/L，2hPG 10.0~11.0 mmol/L。既往体健。查体:T 36 °C，P 78 次/min， R 18 次/min，BP 120/80 mmHg;巩膜不黄，双晶体无混浊;颈软，颈静脉无怒张;心、肺无异常。实 验室检查:Hb 121 g/L，WBC 6.5×10<sup>9</sup>/L，N 0.65，L 0.35，PLT 235×10<sup>9</sup>/L;血糖 11 mmol/L，ALT 14u/L， AST 17.8 u/L , Scr 94umol/L ，BUN 6.1mmol/L, HbA1c 7.3%。</p>
      </div>
      <div class="q">
        <van-row class="q_title">1. 您认为适合为该患者的糖化血红蛋白控制目标为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q1">
          <van-radio name="A">A. ≤7.0%</van-radio>
          <van-radio name="B">B. >7.0-8.0%</van-radio>
          <van-radio name="C">C. <7.5-8.0%</van-radio>
          <van-radio name="D">D. >8.0-8.5%</van-radio>
          <van-radio name="E">
            <van-field v-model="q1_E" label-align="left" class="other" label="E. 其他，请注明"/>
          </van-radio>
        </van-radio-group>
      </div>
      <div class="q">
        <van-row class="q_title">2. 您认为适合为该患者的空腹/餐前血糖控制目标为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q2">
          <van-radio name="A">A. 4.4-7.0mmol/L</van-radio>
          <van-radio name="B">B. 5.0-8.8mmol/L</van-radio>
          <van-radio name="C">C. 5.6-10mmol/L</van-radio>
          <van-radio name="D">
            <van-field v-model="q2_D" label-align="left" class="other" label="D. 其他，请注明"/>
          </van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">3. 您认为适合为该患者的餐后2小时血糖控制目标为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q3">
          <van-radio name="A">A. 5.0-8.3mmol/L</van-radio>
          <van-radio name="B">B. 5.6-10.0mmol/L</van-radio>
          <van-radio name="C">C. 6.1-11.1 mmol/L</van-radio>
          <van-radio name="D">
            <van-field v-model="q3_D" label-align="left" class="other" label="D. 其他，请注明"/>
          </van-radio>
        </van-radio-group>
      </div>
      <div class="q">
        <van-row class="q_title">4. 根据患者情况，您将为该患者制定的降糖药物数量可能为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q4">
          <van-radio name="A">A. 1 种</van-radio>
          <van-radio name="B">B. 2 种</van-radio>
          <van-radio name="C">C. 3 种</van-radio>
          <van-radio name="D">D. 3 种以上</van-radio>
        </van-radio-group>
      </div>
      <div class="q">
        <van-row class="q_title">5. 根据您的评估，该患者合并疾病的严重程度如何?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q5">
          <van-radio name="A">A. 轻度</van-radio>
          <van-radio name="B">B. 中度</van-radio>
          <van-radio name="C">C. 重度/终末期</van-radio>
          <van-radio name="D">D. 未做相关评估</van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">6. 根据该患者的病情，需要其改善生活方式以有利于治疗，影响较大的是?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q6">
          <van-checkbox name="A" shape="square">A. 清淡饮食，不宜油腻，注意安排粗纤维饮食</van-checkbox>
          <van-checkbox name="B" shape="square">B. 合理控制血糖</van-checkbox>
          <van-checkbox name="C" shape="square">C. 注意保暖</van-checkbox>
          <van-checkbox name="D" shape="square">D. 锻炼适度</van-checkbox>
          <van-checkbox name="E" shape="square">E. 戒烟</van-checkbox>
          <van-checkbox name="F" shape="square">F. 戒酒</van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">7. 请问当您为该老年糖尿病患者(≥60岁)选择降糖药物时，您会重点关注哪些方面?（可多选）</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q7">
          <van-checkbox name="A" shape="square">A. 有效降低FPG/PPG</van-checkbox>
          <van-checkbox name="B" shape="square">B. 有效降低HbA1c</van-checkbox>
          <van-checkbox name="C" shape="square">C. 平稳降糖</van-checkbox>
          <van-checkbox name="D" shape="square">D. 低血糖风险小</van-checkbox>
          <van-checkbox name="E" shape="square">E. 药物间相互作用少</van-checkbox>
          <van-checkbox name="F" shape="square">F. 一天一次，服用方便</van-checkbox>
          <van-checkbox name="G" shape="square">G. 不增加体重</van-checkbox>
          <van-checkbox name="H" shape="square">H. 不增加心血管疾病风险</van-checkbox>
          <van-checkbox name="I" shape="square">I. 不增加骨折风险</van-checkbox>
          <van-checkbox name="J" shape="square">J. 对胃肠道的副作用小</van-checkbox>
          <van-checkbox name="K" shape="square">K. 对肝功能影响小</van-checkbox>
          <van-checkbox name="L" shape="square">L. 对肾功能影响小</van-checkbox>
          <van-checkbox name="M" shape="square">M. 指南推荐，适合老年糖尿病患者(≥60岁)</van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">8. 请问您认为应该为该患者制定哪些合并症的控制计划?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q8">
          <van-checkbox name="A" shape="square">A. 控制血压</van-checkbox>
          <van-checkbox name="B" shape="square">B. 控制周围神经病变</van-checkbox>
          <van-checkbox name="C" shape="square">C. 预防认知功能障碍</van-checkbox>
          <van-checkbox name="D" shape="square">D. 预防心血管疾病发生</van-checkbox>
          <van-checkbox name="E" shape="square">E. 预防眼底病变</van-checkbox>
          <van-checkbox name="F" shape="square">
            <van-field v-model="q8_F" label-align="left" v-on:click.stop=stopCheck() class="other" label="F. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">9. 您认为该患者还需要哪些辅助检查</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q9">
          <van-checkbox name="A" shape="square">A. 心脏超声</van-checkbox>
          <van-checkbox name="B" shape="square">B. 平板实验</van-checkbox>
          <van-checkbox name="C" shape="square">C. 平衡和步态评估</van-checkbox>
          <van-checkbox name="D" shape="square">D. 骨密度</van-checkbox>
          <van-checkbox name="E" shape="square">E. 常用简易精神状态检查(MMSE)和简易智力状态评估表(Mini Cog)</van-checkbox>
          <van-checkbox name="F" shape="square">F. 眼底检查</van-checkbox>
          <van-checkbox name="G" shape="square">
            <van-field v-model="q9_G" label-align="left" v-on:click.stop=stopCheck() class="other" label="G. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">10. 除口服降糖药外，您认为该老年糖尿病患者(≥60岁)还需考虑哪些治疗药物?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q10">
          <van-checkbox name="A" shape="square">A. 脱水利尿</van-checkbox>
          <van-checkbox name="B" shape="square">B. 增加骨密度</van-checkbox>
          <van-checkbox name="C" shape="square">C. 改善心功能</van-checkbox>
          <van-checkbox name="D" shape="square">D. 改善认知功能</van-checkbox>
          <van-checkbox name="E" shape="square">
            <van-field v-model="q10_E" label-align="left" v-on:click.stop=stopCheck() class="other" label="E. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <div class="q">
        <van-row class="q_title">11. 您会选择的本次降糖方案为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q11">
          <van-radio name="A">A. 单用药物</van-radio>
          <van-radio name="B">B. 联用药物</van-radio>
        </van-radio-group>
      </div>
      <div class="q">
        <van-row class="q_title">12. 若您选择单用药物，您选择的本次降糖方案为?</van-row>
        <div class="clear"></div>
        <van-radio-group v-model="q12">
          <van-radio name="A">A. α-糖苷酶抑制剂</van-radio>
          <van-radio name="B">B. 双胍类</van-radio>
          <van-radio name="C">C. 格列奈类</van-radio>
          <van-radio name="D">D. 磺脲类</van-radio>
          <van-radio name="E">E. DPP-4 抑制剂</van-radio>
          <van-radio name="F">F. 格列酮类</van-radio>
          <van-radio name="G">G. GLP-1 受体激动剂</van-radio>
          <van-radio name="H">H. 胰岛素</van-radio>
        </van-radio-group>
      </div>

      <div class="q">
        <van-row class="q_title">13. 若您选择联用药物，您选择的本次降糖方案为?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q13">
          <van-checkbox name="A" shape="square">A. α-糖苷酶抑制剂</van-checkbox>
          <van-checkbox name="B" shape="square">B. 双胍类</van-checkbox>
          <van-checkbox name="C" shape="square">C. 格列奈类</van-checkbox>
          <van-checkbox name="D" shape="square">D. 磺脲类</van-checkbox>
          <van-checkbox name="E" shape="square">E. DPP-4 抑制剂</van-checkbox>
          <van-checkbox name="F" shape="square">F. 格列酮类</van-checkbox>
          <van-checkbox name="G" shape="square">G. GLP-1 受体激动剂</van-checkbox>
          <van-checkbox name="H" shape="square">H. 胰岛素</van-checkbox>
        </van-checkbox-group>
      </div>

      <div class="q">
        <van-row class="q_title">14. 请问您为该患者设置的综合生活质量改善目标有哪些?</van-row>
        <div class="clear"></div>
        <van-checkbox-group v-model="q14">
          <van-checkbox name="A" shape="square">A. 改善认知功能</van-checkbox>
          <van-checkbox name="B" shape="square">B. 提高日常活动能力</van-checkbox>
          <van-checkbox name="C" shape="square">C. 降低跌倒风险</van-checkbox>
          <van-checkbox name="D" shape="square">D. 降低骨折风险</van-checkbox>
          <van-checkbox name="E" shape="square">E. 防止周围神经病变恶化</van-checkbox>
          <van-checkbox name="F" shape="square">F. 减少服药种类，减少过度治疗</van-checkbox>
          <van-checkbox name="G" shape="square">G. 减少日服药次数，提高依从性</van-checkbox>
          <van-checkbox name="H" shape="square">H. 避免胃肠道不良反应</van-checkbox>
          <van-checkbox name="I" shape="square">I. 避免药物对肝肾功能的影响</van-checkbox>
          <van-checkbox name="J" shape="square">
            <van-field v-model="q14_J" label-align="left" v-on:click.stop=stopCheck() class="other" label="J. 其他，请注明"/>
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <div class="apply">
        <van-button type="info" class="apply_title" @click="submit()">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
// import validator from '@/utils/validator.js'
import Cookies from 'js-cookie'

export default {
  name: "Question4",
  data() {
    return {
      q1: [],
      q2: [],
      q3: [],
      q4: [],
      q5: [],
      q6: [],
      q7: [],
      q8: [],
      q9: [],
      q10: [],
      q11: [],
      q12: [],
      q13: [],
      q14: [],
      q1_E: "",
      q2_D: "",
      q3_D: "",
      q5_D: "",
      q8_F: "",
      q9_G: "",
      q10_E: "",
      q14_J: "",
      periods: 1,
       isSubmit: false,
    };
  },

  methods: {
    // 阻止点击输入引起checkbox 选中变好
    stopCheck(){
      return false;
    },
    // 判断是否答题
    isAnswer(q, answer) {
      if (answer.length == 0) {
        this.$dialog.alert({
          message: "第" + q + "题没有选择"
        });
        return false;
      }
      return true;
    },
       // 弹框
    customAlert(msg){
      this.$dialog.alert({
          message: msg
      });
      return
    },
      // 弹框 确定后返回列表
    customAlert2(msg){
      this.$dialog.alert({
          message: msg
      }).then(
        ()=> {
          this.$router.go(-1);//返回上一层
        }
      )
      return
    },
    // 提交数据
    submit() {
        if(this.isSubmit){
        this.customAlert('正在提交')
        return false
      }
      this.isSubmit = true
      // 去除空格
      this.q1_E = this.q1_E.trim();
      this.q2_D = this.q2_D.trim();
      this.q3_D = this.q3_D.trim();
      this.q8_F = this.q8_F.trim();
      this.q9_G = this.q9_G.trim();
      this.q10_E = this.q10_E.trim();
      this.q14_J = this.q14_J.trim();

      // 判断是否楼选
      const a1 = this.isAnswer(1, this.q1);
      const a2 = this.isAnswer(2, this.q2);
      const a3 = this.isAnswer(3, this.q3);
      const a4 = this.isAnswer(4, this.q4);
      const a5 = this.isAnswer(5, this.q5);
      const a6 = this.isAnswer(6, this.q6);
      const a7 = this.isAnswer(7, this.q7);
      const a8 = this.isAnswer(8, this.q8);
      const a9 = this.isAnswer(9, this.q9);
      const a10 = this.isAnswer(10, this.q10);
      const a11 = this.isAnswer(11, this.q11);
      const a12 = this.isAnswer(12, this.q12);
      const a13 = this.isAnswer(13, this.q13);
      const a14 = this.isAnswer(14, this.q14);

      // 判断是否选了其他，但是还没填其他
      if (a1 && this.q1.includes("E") && this.q1_E.length == 0) {
        this.$dialog.alert({
          message: "请把第1题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }

      // 判断是否选了其他，但是还没填其他
      if (a2 && this.q2.includes("D") && this.q2_D.length == 0) {
        this.$dialog.alert({
          message: "请把第2题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }

      // 判断是否选了其他，但是还没填其他
      if (a3 && this.q3.includes("D") && this.q3_D.length == 0) {
        this.$dialog.alert({
          message: "请把第3题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }

      // // 判断是否选了其他，但是还没填其他
      // if (a4 && this.q4.includes("D") && this.q4_D.length == 0) {
      //   this.$dialog.alert({
      //     message: "请把第4题的其他的内容也填写一下"
      //   });
      //   return;
      // }

      // 判断是否选了其他，但是还没填其他
      // if (a5 && this.q5.includes("D") && this.q5_D.length == 0) {
      //   this.$dialog.alert({
      //     message: "请把第5题的其他的内容也填写一下"
      //   });
      //   return;
      // }

      // 判断是否选了其他，但是还没填其他
      if (a8 && this.q8.includes("F") && this.q8_F.length == 0) {
        this.$dialog.alert({
          message: "请把第8题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }

      // 判断是否选了其他，但是还没填其他
      if (a9 && this.q9.includes("G") && this.q9_G.length == 0) {
        this.$dialog.alert({
          message: "请把第9题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }

      // 判断是否选了其他，但是还没填其他
      if (a10 && this.q10.includes("E") && this.q10_E.length == 0) {
        this.$dialog.alert({
          message: "请把第10题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }

      // 判断是否选了其他，但是还没填其他
      if (a14 && this.q14.includes("J") && this.q14_J.length == 0) {
        this.$dialog.alert({
          message: "请把第14题的其他的内容也填写一下"
        });
         this.isSubmit = false
        return;
      }

      if (
        !(
          a1 &&
          a2 &&
          a3 &&
          a4 &&
          a5 &&
          a6 &&
          a7 &&
          a8 &&
          a9 &&
          a10 &&
          a11 &&
          a12 &&
          a13 &&
          a14
        )
      ) {
         this.isSubmit = false
        return;
      }

      // 提交数据
      let data = {};
      data.uid = Cookies.get('uid');
      data.question = 4;
      data.periods = this.periods;
      let answer = {};
      answer.q1 = this.q1;
      answer.q2 = this.q2;
      answer.q3 = this.q3;
      answer.q4 = this.q4;
      answer.q5 = this.q5;
      answer.q6 = this.q6;
      answer.q7 = this.q7;
      answer.q8 = this.q8;
      answer.q9 = this.q9;
      answer.q10 = this.q10;
      answer.q11 = this.q11;
      answer.q12 = this.q12;
      answer.q13 = this.q13;
      answer.q14 = this.q14;
      answer.q1_E = this.q1_E;
      answer.q2_D = this.q2_D;
      answer.q3_D = this.q3_D;
      answer.q8_F = this.q8_F;
      answer.q9_G = this.q9_G;
      answer.q10_E = this.q10_E;
      answer.q14_J = this.q14_J;
      data.answer = answer;
      Http.post(api.answer, data).then(response => {
         this.isSubmit = false
        if (response.code == 1) {
          // 提交成功
          this.customAlert2("提交成功");
          return false;
        } else {
          // 发送失败
          this.customAlert(response.msg);
          return false;
        }
      });
      return false;
    }
  },
   mounted: function() {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    this.periods = this.$route.query.periods
  },
};
</script>

<style lang="less">
.question4 {
  font-size: 16px;
  .header {
    img {
      width: 100%;
      display: block;
    }
  }
  .van-cell {
    font-size: 16px;
  }
  .van-col {
    margin-bottom: 20px;
  }
  .van-field__body {
    border-bottom: 2px solid #f7f7f7;
  }
  .clear {
    clear: both;
  }
  .van-radio {
    margin: 12px;
  }
  .van-checkbox {
    margin-left: 12px;
  }
  .van-checkbox__label {
    margin: 12px;
    text-align: left;
  }
  .margin-right-12 {
    margin-right: 12px;
  }
  .margin-bottom-12 {
    margin-bottom: 12px;
  }
  table,
  th,
  td {
    border: 1px solid black;
  }
  .van-field__label {
    width: 120px;
  }

  .other {
    padding: 0px;
    text-align: left;
  }
  .body {
    //margin-top: .5rem;
    .title {
      text-align: center;
      font-size: 24px;
    }
    .content {
      margin: 12px;
      text-indent: 34px;
    }
    .q {
      margin-left: 16px;
      margin-right: 12px;
      .q_title {
        float: left;
        text-align: left;
      }
    }
    .apply {
      text-align: center;
      &_title {
        font-size: 18px;
        width: 50%;
        color: #007bf7;
        background-color: #fff;
        border-radius: 1rem;
        margin-bottom: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Question4.vue